import Swiper from 'swiper'
import 'swiper/css/swiper.css'

export default function slideShowSlider() {
  const sliderContainer = document.querySelector('.slide-show-slider .swiper-container')

  if (sliderContainer) {
    const speed = 2000

    new Swiper(sliderContainer, {
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed,
      loop: true,
      allowTouchMove: true,
      grabCursor: true,
      on: {
        slideChangeTransitionStart: () => {
          const swiperSlidePrev = sliderContainer.querySelector('.swiper-slide-prev')
          const swiperSlideNext = sliderContainer.querySelector('.swiper-slide-next')
          if (swiperSlidePrev && swiperSlideNext) {
            swiperSlidePrev.classList.add('scale')
            swiperSlideNext.classList.add('scale')
          }
        },
        slideChangeTransitionEnd: () => {
          const swiperSlidePrev = sliderContainer.querySelector('.swiper-slide-prev')
          if (swiperSlidePrev) {
            swiperSlidePrev.classList.remove('scale')
          }
        },
        slideNextTransitionEnd: () => {
          const swiperSlideNext = sliderContainer.querySelector('.swiper-slide-next')
          if (swiperSlideNext) {
            swiperSlideNext.classList.remove('scale')
          }
        },
      },
    })
  }
}
